import { connect } from 'react-redux';
//import { orderBy } from 'lodash';

import settings from '../../settings';

import { openDialogError } from '../../actions/DialogError';
import { closeDialog } from '../../actions/Dialog';
import { changeGameVersionMod } from '../../actions/EditMod';

import DialogChangeGameVersionMod from '../../components/Dialogs/DialogChangeGameVersionMod/DialogChangeGameVersionMod';

const mapStateToProps = (state, ownProps) => ({
    realm: state.currentAccount.realm,
    //data: state.adminPanel.data,
    user: state.adminPanel.user,

    lastGameVersionId: settings.gameVersions[0].id,

    //id: ownProps.gameVersionId,
    //versions: orderBy(ownProps.versions, ['id'], ['desc']),
})

const mapDispatchToProps = (dispatch) => ({
    onComponentWillMount: (ownerId) => {
        //dispatch(fetchUserData(ownerId))
    },

    onShowDialogError: (content) => {
        dispatch(openDialogError(content))
    },
    onSubmitDialog: (data) => {
        dispatch(changeGameVersionMod(data))
        dispatch(closeDialog())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(DialogChangeGameVersionMod)
